import { useContext } from "react";
import { StudentsContext } from "./StudentsContext";

export default () => {
    const context = useContext(StudentsContext);

    if (context === undefined) throw new Error("useStudents must be used within a StudentsProvider");

    return context;
};
